export default __webpack_public_path__ + "static/media/09_photo.3284e5bf.jpg";